export default {
  General: {
    Email: "メールアドレス",
    Send: "送信",
    Done: "完了",
    Finish: "完了",
    Try_again: "もう一度試す",
    or: "または"
  },
  SamsungType: {
    bixby: "Bixbyがある場合",
    no_bixby: "Bixbyがない場合",
    home_button: "ホームボタンがある"
  },
  sendEmail: {
    repair_tip1: "このモデルは、モバイルアプリでは修復できません。デスクトップでの解除方法をメールでお知らせいたします。",
    check_tip1: "モバイルアプリのみではデバイスチェックを完了できません。デスクトップ版の解決策をメールでお送りします。",
    tip1: "このモデルは、モバイルアプリではロック解除できません。デスクトップでの解除方法をメールでお知らせいたします。",
    tip2: "成功率を上げるためにデバイスとコンピューターをデータケーブルで接続してください。",
    enter_address: "メールアドレスを入力してください。",
    enter_correct_address: "正しいメールアドレスを入力してください。",
    confidential: "ご入力いただいたメールアドレスは極秘に扱われます。",
    open_link: "コンピューターの任意のブラウザーで{0}を開き、Dr.Foneをダウンロードします。",
    has_sent: "メールが送信されました",
    almost: "もう少しで完了です",
    step1: "ステップ1",
    open_email: "コンピューターでメールを開き、送信されたリンクにアクセスしてDr.Foneのデスクトップ版をダウンロードします。",
    step2: "ステップ2",
    repair_launch_tip: "Dr.Fone System Repairを起動し、アカウントにログインして修復機能を使用してください。",
    check_launch_tip: "Dr.Fone デスクトップ版をインストールし、同じアカウントでサインインしてください。「My Device」をクリックし、画面の指示に従ってデバイスを接続します。接続後、「Device Detail」をクリックして詳細なチェック結果を表示します。",
    launch_tip: "Dr.Foneロック解除を起動してアカウントにログインし、ロック解除機能を使用します。",
    contact_us: "ご不明な点は当社にお問い合わせください。"
  },
  Unlock: {
    recoveryMode: "デバイスをリカバリモードに移行",
    wipe_cache: "デバイスのキャッシュパーティションを消去します。",
    wipe_data: "指示に従って、デバイスのデータを消去します。",
    completed: "ロック解除が完了しました",
    completed_tip: "デバイスの画面ロック解除が成功したかどうかを確認します。成功していない場合は、もう一度お試しください。",
    contact_us: "ロック解除できませんでしたか？当社までお問い合わせください。"
  },
  UnlockStep: {
    sa1: "1.デバイスの電源をオフにし、デバイスをコンピューターに接続したままにします。 ",
    sa2: "2.音量アップボタン + Bixbyボタン + 電源ボタンを同時に長押しします。",
    sa3: "3.Samsungのロゴが表示されたら手を離し、数秒間待ちます。",
    sa4: "4.デバイスがリカバリモードで起動します。[Reboot to bootloader]を選択して、ダウンロードモードに移行します。",
    sb1: "1.デバイスの電源をオフにし、デバイスをコンピューターに接続したままにします。",
    sb2: "2.電源ボタン + 音量アップボタンを同時に長押しします。",
    sb3: "3.デバイスがバックアップを開始した後も、この2つのボタンを押し続けます。",
    sb4: "4.デバイスがリカバリモードで起動します。[Reboot to bootloader]を選択して、ダウンロードモードに移行します。",
    sc1: "1.デバイスの電源をオフにし、デバイスをコンピューターに接続したままにします。",
    sc2: "2.音量アップボタン + ホームボタン + 電源ボタンを同時に長押しします。",
    sc3: "3.Samsungのロゴが表示されたら手を離し、数秒間待ちます。",
    sc4: "4.デバイスがリカバリモードで起動します。[Reboot to bootloader]を選択して、ダウンロードモードに移行します。",
    s5: "5.音量ボタンを押して[Wipe data/factory reset]を選択し、電源ボタンを押して確定します。",
    s6: "6.音量ボタンを押して[Yes]を選択し、電源ボタンを押して確定します。",
    s7: "7.[Wipe cache partition]を押して、[Yes]を選択します。",
    s8: "8.[reboot system now]を選択し、電源ボタンを押して確定します。デバイスの再起動には時間がかかります。",
    common1: "デバイスの電源をオフにします。",
    common2: "音量アップキーと電源キーを数秒間押し続けます。",
    common3: "画面にリカバリモードが表示されたら、両方のキーから手を離します。",
    m4: "音量キーで[Wipe Data]を選択し、電源ボタンで確定します。",
    m5: "[Wipe All Data]を選択します。",
    m6: "次に[Confirm]を選択し、プロセスが終了するまで待ちます。",
    m7: "電源キーを使用してメインメニューに戻ります。",
    m8: "[Reboot]を選択します。",
    m9: "最後に、[Reboot to system]を選択します。",
    h4: "音量キーで[Clear data]を選択し、電源ボタンで確定します。",
    h5: "[Factory reset]を選択します。",
    h6: "「Yes」と入力し、[Factory reset]を選択します。",
    h7: "この操作で、すべてのファイルが削除されます。",
    h8: "[Back]を選択してメインメニューに戻ります。",
    h9: "最後に、[Restart]を選択します。"
  }
};
